var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.5C4.5 11.7761 4.72385 12 5 12C5.27614 12 5.5 11.7761 5.5 11.5L5.5 1.80298L9.12835 5.83448C9.31308 6.03974 9.62922 6.05638 9.83448 5.87165C10.0397 5.68692 10.0564 5.37077 9.87164 5.16552L5.37164 0.165518C5.27682 0.0601606 5.14174 0 5 0C4.85825 0 4.72317 0.0601606 4.62835 0.165518L0.128349 5.16552C-0.0563803 5.37077 -0.0397415 5.68692 0.165514 5.87165C0.370769 6.05638 0.686913 6.03974 0.871643 5.83448L4.5 1.80298L4.5 11.5Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.2fc956e1ae9cece05118cedeb135730a.svg";
export { ForwardRef as ReactComponent };